import { recipeSlice } from "./store/recipe.slice";
import {
  recipeApi,
  useGetRecipesQuery,
  useCreateRecipeMutation,
  useUpdateRecipeMutation,
  useLazyGetRecipeByIdQuery,
  useLazyGetRecipesQuery,
  useDeleteRecipeMutation
} from "./api/recipe.api";

export const { setRecipes } = recipeSlice.actions;

export {
  recipeApi,
  recipeSlice,
  useGetRecipesQuery,
  useCreateRecipeMutation,
  useUpdateRecipeMutation,
  useLazyGetRecipeByIdQuery,
  useLazyGetRecipesQuery,
  useDeleteRecipeMutation
};
